module.exports = __webpack_public_path__ + "static/img/picc1.21f5a7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/picc1.png
// module id = 48MS
// module chunks = 0